@if (dropdownType == DropdownType.Date) {
  <div>
    <button #trigger type="text" (click)="openDropdown()" class="flex items-center pl-2 pr-2 pb-0 bg-white font-semibold text-momentum-deep_purple rounded-md border-momentum-deep_purple border text-xs sm:text-sm w-[112px] sm:w-[125px] pt-0">
      {{ selectedOption?.displayName }} <fa-icon [icon]="isDropdownOpen ? faAngleUp : faAngleDown" class="ml-1 text-base font-semibold text-momentum-deep_purple"></fa-icon>
    </button>
    <ng-template #dropdownTemplate>
      <div class="dropdown py-2 px-3 w-[112px] rounded-lg mt-px">
        <ul cdkListbox>
          @for (option of filteredOptions; track option.displayName) {
            <li [cdkOption]="option.field" (click)="optionSelected(option)" class="text-slate-500 text-xs pb-2 last-of-type:pb-0">{{ option.displayName }}</li>
          }

          @if (filteredOptions.length === 0) {
            <li cdkOption="noResults" cdkOptionDisabled class="disable-option">No results.</li>
          }
        </ul>
      </div>
    </ng-template>
  </div>
}

@if (dropdownType == DropdownType.Profile) {
  <div>
    <button #trigger (click)="openDropdown()"><fa-icon [icon]="isDropdownOpen ? faChevronUp : faChevronDown" size="xl"></fa-icon></button
    >
    <ng-template #dropdownTemplate>
      <div class="dropdown p-2 rounded-lg mt-px right-[-20px] top-[19px]">
        <ul cdkListbox>
          @for (option of filteredOptions; track option.displayName) {
            <li [cdkOption]="option.field" (click)="optionSelected(option)" class="text-slate-600 pb-2 last-of-type:pb-0">{{ option.displayName }}</li>
          }
          @if (filteredOptions.length === 0) {
            <li cdkOption="noResults" cdkOptionDisabled class="disable-option">No results.</li>
          }
        </ul>

      </div>
    </ng-template>
  </div>
}

@if (dropdownType == DropdownType.State) {
  <div>
    <div class="flex flex-row">
      <div class="flex font-bold text-momentum-black flex-wrap">
        All referral activity from the last 72hrs in&nbsp;
        <div>
          <button #trigger type="text" (click)="openDropdown()" class="flex font-bold bg-transparent border-none p-0 text-sm focus:ring-transparent">
            <div class="text-momentum-black underline">{{ selectedOption?.displayName }}</div>
            <fa-icon [icon]="isDropdownOpen ? faChevronUp : faChevronDown" class="text-momentum-black relative px-1"></fa-icon>
          </button>
        </div>
        <ng-template #dropdownTemplate>
          <div class="dropdown py-2 px-3 w-[112px] rounded-lg mt-px max-h-[50dvh] overflow-auto">
            <ul cdkListbox>
              @for (option of filteredOptions; track option.displayName) {
                <li [cdkOption]="option.field" (click)="optionSelected(option)" class="text-momentum-black text-xs pb-2 last-of-type:pb-0">{{ option.displayName }}</li>
              }

              @if (filteredOptions.length === 0) {
                <li cdkOption="noResults" cdkOptionDisabled class="disable-option">No results.</li>
              }
            </ul>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
}
